import { render } from "./ServiceError.vue?vue&type=template&id=3a06cd24"
import script from "./ServiceError.vue?vue&type=script&lang=js"
export * from "./ServiceError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__